import { createAction, createAsyncAction } from 'typesafe-actions'
import {
  ConfirmReceivedAmountRequestDto,
  ConfirmReceivedAmountResponseDto,
  CurrenciesCrypto,
  WsEvent,
  WsEventType,
  RequestSettlementRequestDto,
  RequestSettlementResponseDto,
} from '@sparling/financial-common'

export const resetAddNewWalletPopup = createAction('RESET_ADD_NEW_WALLET_POPUP')<void>()

export const openAddNewWalletPopup = createAction('OPEN_ADD_NEW_WALLET_POPUP')<{
  open: boolean
  currency?: CurrenciesCrypto
}>()

export const openAwaitingDepositPopup = createAction('OPEN_AWAITING_DEPOSIT_POPUP')<{
  address: string
  created: Date | null
}>()

export const openConfirmReceivedAmountPopup = createAction('OPEN_CONFIRM_RECEIVED_AMOUNT_POPUP')<{
  open: boolean
  walletId?: string
}>()

export const {
  request: confirmReceivedAmountRequest,
  success: confirmReceivedAmountSuccess,
  failure: confirmReceivedAmountFailure,
} = createAsyncAction(
  'CONFIRM_RECEIVED_AMOUNT_REQUEST',
  'CONFIRM_RECEIVED_AMOUNT_SUCCESS',
  'CONFIRM_RECEIVED_AMOUNT_FAILURE',
)<ConfirmReceivedAmountRequestDto, ConfirmReceivedAmountResponseDto, Error>()

export const userExternalWalletStatusUpdated = createAction('USER_EXTERNAL_WALLETS_STATUS_UPDATED')<
  WsEvent<WsEventType.USER_EXTERNAL_WALLET_STATUS_UPDATED>['payload']
>()

export const openRequestSettlementPopup = createAction('OPEN_REQUEST_SETTLEMENT_POPUP')<{ open: boolean }>()

export const {
  request: createSettlementRequest,
  success: createSettlementSuccess,
  failure: createSettlementFailure,
} = createAsyncAction('CREATE_SETTLEMENT_REQUEST', 'CREATE_SETTLEMENT_SUCCESS', 'CREATE_SETTLEMENT_FAILURE')<
  RequestSettlementRequestDto,
  RequestSettlementResponseDto,
  Error
>()
